module.exports = __webpack_public_path__ + "img/business_pay_04.0de43113.png";